import { UseFormPayload } from '@domain-group/react-hooks'
import { Form, SectionDivider } from '@domain-group/suit-theme'

interface PropertyDetailsProps {
  campaignComparableFormPayload: UseFormPayload,
}

const PropertyFeatures = (props: PropertyDetailsProps) => {
  const { campaignComparableFormPayload } = props

  const {
    entityState: {
      bathrooms,
      bedrooms,
      carparks,
      land_area,
      property_type,
    },
    errors,
    handlers,
  } = campaignComparableFormPayload

  return (
    <>
      <SectionDivider boxProps={{ marginTop: 'large' }}>Property Features</SectionDivider>

      <Form.Row columns="repeat(3, 1fr)">
        <Form.Field label="* Bedrooms" errorMessage={errors.bedrooms} hideErrorMessage marginTop="large">
          <input name="bedrooms" type="text" value={bedrooms} {...handlers} />
        </Form.Field>

        <Form.Field label="* Bathrooms" errorMessage={errors.bathrooms} hideErrorMessage marginTop="large">
          <input name="bathrooms" type="text" value={bathrooms} {...handlers} />
        </Form.Field>

        <Form.Field label="* Carparks" errorMessage={errors.carparks} hideErrorMessage marginTop="large">
          <input name="carparks" type="text" value={carparks} {...handlers} />
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field label="Land Area" marginTop="large">
          <input name="land_area" type="text" value={land_area} {...handlers} />
        </Form.Field>

        <Form.Field label="* Property Type" errorMessage={errors.property_type} hideErrorMessage marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <select name="property_type" value={property_type} {...handlers}>
            <option value="">Please Select...</option>
            <option value="House">House</option>
            <option value="Unit">Unit</option>
            <option value="Vacant Land">Vacant Land</option>
          </select>
        </Form.Field>
      </Form.Row>
    </>
  )
}

export default PropertyFeatures
